import { useState, useEffect } from "react";

const PropertyList = ({
  properties,
  setSelectedpropertie,
  setShowDeleteModel,
  setShowAddBuildingModel,
  setShowEditPropertyModel,
  setShowEditBuildingModal,
  setInitialPropertyName,
  isActionsDisabled,
}) => {
  const [openDropdownId, setOpenDropdownId] = useState(null);
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = () => setOpenDropdownId(null);
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleDropdownToggle = (e, property) => {
    e.stopPropagation();
    setOpenDropdownId(prevId => prevId === property.unid ? null : property.unid);
  };

  return (
    <>
      <div className="mt-4 unitsListHolder rounded-md shadow-appShadow relative overflow-visible">
        <table className="w-full bg-white overflow-auto rounded-md table">
          <thead>
            <tr className="bg-[#E2E8E6] dark:bg-darkThemeTableHeadRowBg *:dark:text-white dark:border-b dark:border-b-darkThemeTableRowBorder">
              <th className="text-xs leading-4 lg:text-sm lg:leading-5 text-dark-grey px-3 py-2 lg:px-5 lg:py-4 text-left font-semibold whitespace-nowrap">
                Property Name
              </th>
              <th className="text-xs leading-4 lg:text-sm lg:leading-5 text-dark-grey px-3 py-2 lg:px-5 lg:py-4 text-left font-semibold whitespace-nowrap">
                No. of Buildings
              </th>
              <th className="text-xs leading-4 lg:text-sm lg:leading-5 text-dark-grey px-3 py-2 lg:px-5 lg:py-4 text-left font-semibold whitespace-nowrap">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {properties?.map((property, idx) => (
              <tr
                key={property.unid}
                className="border-b border-b-[#DDDFDF] last:border-none hover:bg-gray-100 dark:bg-darkThemeTableBodyRowBg dark:border-b-darkThemeTableRowBorder *:dark:text-white"
                onClick={() => setSelectedpropertie(property)}
                data-testid={`property-list-row-${property.unid}`}
              >
                <td className="text-sm leading-5 lg:text-base lg:leading-6 text-dark-grey px-3 py-2 lg:px-5 lg:py-4 text-left font-normal whitespace-nowrap">
                  <p className="truncate max-w-80" title={property.name} data-testid={`property-list-name-${property.unid}`}>{property.name}</p>
                </td>
                <td className="text-sm leading-5 lg:text-base lg:leading-6 text-dark-grey px-3 py-2 lg:px-5 lg:py-4 text-left font-normal whitespace-nowrap" data-testid={`property-list-buildings-count-${property.unid}`}>
                  {property.buildings ? property.buildings.length : 0}
                </td>
                <td className="text-sm leading-5 lg:text-base lg:leading-6 text-dark-grey px-3 py-2 lg:px-5 lg:py-4  text-left font-normal whitespace-nowrap">
                  <div className="actionHolder size-4 lg:size-6 relative">
                    <button
                      onClick={(e) => {
                        if (isActionsDisabled) return;
                        handleDropdownToggle(e, property);
                      }}
                      className={`p-1 rounded-full ${isActionsDisabled ? "opacity-50 cursor-not-allowed" : ""}`}
                      disabled={isActionsDisabled}
                      aria-disabled={isActionsDisabled}
                      data-testid={`property-list-actions-toggle-${property.unid}`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="none"
                      >
                        <circle cx="5" cy="12" r="2" fill={isActionsDisabled ? "#AFC3BC" : "#FF8C65"} />
                        <circle cx="12" cy="12" r="2" fill={isActionsDisabled ? "#AFC3BC" : "#FF8C65"} />
                        <circle cx="19" cy="12" r="2" fill={isActionsDisabled ? "#AFC3BC" : "#FF8C65"} />
                      </svg>
                    </button>

                    {/* GLOBAL FLOATING DROPDOWN */}
                    {!isActionsDisabled && openDropdownId === property.unid && (
                      <div
                        className={`dropdownContent min-w-24 text-nowrap ${idx < 5 ? "top-full left-2.5" : "bottom-full left-2.5"} absolute z-50 bg-[#FFF4D1] dark:bg-darkThemeDropdownBg dark:shadow-darkThemeDropdownMenuShadow rounded-lg shadow-appShadow cursor-pointer`}
                        onClick={(e) => e.stopPropagation()}
                        data-testid={`property-list-actions-menu-${property.unid}`}
                      >
                        <ul className="flex flex-col">
                          <li
                            className="px-4 py-2 text-sm text-dark-grey dark:text-white cursor-pointer border-b border-gray-300 dark:border-darkThemeBorder"
                            onClick={() => {
                              setSelectedpropertie(property);
                              setInitialPropertyName(property.name);
                              setShowEditPropertyModel(true);
                              setOpenDropdownId(null);
                            }}
                            data-testid={`property-list-edit-property-button-${property.unid}`}
                          >
                            Edit Property
                          </li>
                          <li
                            className="px-4 py-2 text-sm text-dark-grey dark:text-white cursor-pointer border-b border-gray-300 dark:border-darkThemeBorder"
                            onClick={() => {
                              setSelectedpropertie(property);
                            setShowEditBuildingModal(true);
                            setOpenDropdownId(null);
                            }}
                            data-testid={`property-list-edit-building-button-${property.unid}`}
                          >
                            Edit Building
                          </li>
                          <li
                            className="px-4 py-2 text-sm text-dark-grey dark:text-white cursor-pointer border-b border-gray-300 dark:border-darkThemeBorder"
                            onClick={() => {
                              setSelectedpropertie(property);
                            setShowAddBuildingModel(true);
                            setOpenDropdownId(null);
                            }}
                            data-testid={`property-list-add-building-button-${property.unid}`}
                          >
                            Add Building
                          </li>
                          <li
                            className="px-4 py-2 text-sm text-dark-grey dark:text-white cursor-pointer border-b border-gray-300 border-none"
                            onClick={() => {
                              setSelectedpropertie(property);
                            setShowDeleteModel(true);
                            setOpenDropdownId(null);
                            }}
                            data-testid={`property-list-delete-property-button-${property.unid}`}
                          >
                            Delete Property
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
            {(!properties || properties.length === 0) && (
              <tr>
                <td colSpan={3} className="text-center py-4 text-gray-500" data-testid="property-list-empty-state">
                  No properties found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PropertyList;
